<!--
exercise/exercise.vue
-->

<!--PERMET DE SÉLECTIONNER 2 OPTIONS DISTINCT-->
<template>
    <div id="s-duoSelector">
        <div v-if="invertTrueFalse">
            <b-button-group>
                <b-button class="btnMarge" :variant="status == true ? getTheme.secondary : getTheme.osecondary" @click="handleInput(true)">{{text1}}</b-button>
                <b-button class="btnMarge" :variant="status == false ? getTheme.secondary : getTheme.osecondary" @click="handleInput(false)">{{text2}}</b-button>
            </b-button-group>
        </div>
        <div v-else>
            <b-button-group>
                <b-button class="btnMarge" :variant="status == false ? getTheme.secondary : getTheme.osecondary" @click="handleInput(false)">{{text1}}</b-button>
                <b-button class="btnMarge" :variant="status == true ? getTheme.secondary : getTheme.osecondary" @click="handleInput(true)">{{text2}}</b-button>
            </b-button-group>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default{
    name: 's-duoSelector',
    props: {
        text1: String,
        text2: String,
        value: Boolean,
        invertTrueFalse: Boolean
    },
    data() {
        return {
            statusV: false
        }
    },
    methods: {
        handleInput(valeur) {
            this.statusV = valeur;
            this.$emit('update:returnValue', valeur)
        }
    },
    computed: {
        ...mapGetters(['getTheme']),
        status() {
            return this.value
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/components/duoSelector.scss'
</style>